<div class="matrix" [class.minified]="isMinifiedView">
  <div
    class="form-page-header"
    [class.fixed]="!inDialog && (loadingAction | actionInProgress: true | async) === false"
  >
    <h1>{{ 'competenceMatrix' | translate | titlecase }}</h1>
    @if (!!(matrix$ | async)) {
      <div class="matrix-controls">
        <app-ui-button
          text="{{ 'print' | translate }}"
          buttonType="secondary"
          [disabled]="(printAction | actionInProgress | async) === true"
          (click)="print()"
        ></app-ui-button>
        <app-ui-button
          text="{{ 'sendNotifications' | translate }}"
          buttonType="secondary"
          (click)="sendNotifications()"
        ></app-ui-button>
        <mat-button-toggle-group
          [value]="isMinifiedView"
          (change)="isMinifiedView = !isMinifiedView"
        >
          <mat-button-toggle [value]="false">{{ 'matrix' | translate }}</mat-button-toggle>
          <mat-button-toggle [value]="true">{{ 'basic' | translate }}</mat-button-toggle>
        </mat-button-toggle-group>
      </div>
    }
    <div class="filtering-row form-row">
      @if (showDepartmentFilter) {
        <div class="filtering-element">
          <app-ui-select
            label="{{ 'department' | translate }}"
            [control]="departmentControl"
            [options]="departments$ | async"
            [isMultiple]="false"
            [disabled]="(departmentsLoadingAction | actionInProgress | async) === true"
            (changeHandler)="onDepartmentSelected()"
          ></app-ui-select>
          @if (departmentControl.value) {
            <app-ui-button
              text="{{ 'clear' | translate }}"
              buttonType="icon-button"
              icon="close"
              (click)="clearDepartment()"
            ></app-ui-button>
          }
        </div>
      }
      @if (showShiftFilter) {
        <div class="filtering-element">
          <app-ui-select
            label="{{ 'shift' | translate }}"
            [control]="shiftControl"
            [options]="shifts$ | async"
            [isMultiple]="false"
            [disabled]="
              !departmentControl.value || (shiftsLoadingAction | actionInProgress | async) === true
            "
            (changeHandler)="onShiftSelected()"
          ></app-ui-select>
          @if (shiftControl.value) {
            <app-ui-button
              text="{{ 'clear' | translate }}"
              buttonType="icon-button"
              icon="close"
              (click)="clearShift()"
            ></app-ui-button>
          }
        </div>
      }
      @if (showTripFilter) {
        <div class="filtering-element">
          <app-ui-select
            label="{{ 'trip' | translate }}"
            [control]="tripControl"
            [options]="trips$ | async"
            [isMultiple]="false"
            [disabled]="(tripsLoadingAction | actionInProgress | async) === true"
            (changeHandler)="onTripSelected()"
          ></app-ui-select>
          @if (tripControl.value) {
            <app-ui-button
              text="{{ 'clear' | translate }}"
              buttonType="icon-button"
              icon="close"
              (click)="clearTrip()"
            ></app-ui-button>
          }
        </div>
      }
      <div class="filtering-element">
        <app-ui-select
          label="{{ 'excludedUsers' | translate }}"
          [control]="excludedUsersControl"
          [options]="userOptions"
          [isMultiple]="true"
          (changeHandler)="excludeUsers()"
        ></app-ui-select>
        @if (excludedUsersControl.value?.length) {
          <app-ui-button
            text="{{ 'clear' | translate }}"
            buttonType="icon-button"
            icon="close"
            (click)="clearExcludedUsers()"
          ></app-ui-button>
        }
      </div>
      <div class="filtering-element">
        <app-ui-select
          label="{{ 'excludedCompetences' | translate }}"
          [control]="excludedCompetencesControl"
          [options]="competenceOptions"
          [isMultiple]="true"
          (changeHandler)="excludeCompetences()"
        ></app-ui-select>
        @if (excludedCompetencesControl.value?.length) {
          <app-ui-button
            text="{{ 'clear' | translate }}"
            buttonType="icon-button"
            icon="close"
            (click)="clearExcludedCompetences()"
          ></app-ui-button>
        }
      </div>
      @if (showDateFilter) {
        <div class="filtering-element">
          <app-shared-ui-datepicker
            label="{{ 'startDate' | translate }}"
            [control]="pivotDateControl"
            (changeHandler)="changeDate()"
          ></app-shared-ui-datepicker>
        </div>
      }
    </div>
  </div>
  <div
    *appLoader="(loadingAction | actionInProgress: true | async) === true"
    class="matrix-container"
    appFitToViewport
    [bottomOffset]="2"
    [class.no-padding]="inDialog"
  >
    @if (competences.length) {
      <table (mouseleave)="selectedColumn = null; selectedRow = null" class="matrix-table">
        @if (users.length) {
          <thead>
            <tr>
              <th></th>
              @for (competence of competences; track $index; let competenceIndex = $index) {
                <th
                  class="competence-name"
                  matTooltipClass="competence-matrix-tooltip"
                  [class.highlighted]="selectedColumn === competenceIndex"
                  [matTooltip]="competence.name || ''"
                  (mouseenter)="selectedColumn = competenceIndex"
                  (mouseleave)="selectedColumn = null"
                >
                  {{ competence.code | slice: 0 : (isMinifiedView ? 3 : 10) | uppercase }}
                </th>
              }
            </tr>
          </thead>
          <tbody>
            @for (user of users; track $index; let userIndex = $index) {
              <tr>
                <th
                  class="user"
                  [class.highlighted]="selectedRow === userIndex"
                  (mouseenter)="selectedRow = userIndex; selectedColumn = null"
                  (mouseleave)="selectedRow = null"
                >
                  <app-user-card [user]="user">
                    <button mat-menu-item (click)="navigateToUser(user)">
                      <span>{{ 'goToUser' | translate }}</span>
                    </button>
                    @if (user.allowNotifications) {
                      <button mat-menu-item (click)="sendSingleNotification(user)">
                        <span>{{ 'sendNotification' | translate }}</span>
                      </button>
                    }
                  </app-user-card>
                </th>
                @for (
                  competence of user.competenceStatuses;
                  track $index;
                  let competenceIndex = $index
                ) {
                  <td
                    class="competence-status"
                    [class.highlighted]="
                      selectedColumn === competenceIndex || selectedRow === userIndex
                    "
                    (mouseenter)="selectedRow = userIndex; selectedColumn = competenceIndex"
                    (mouseleave)="selectedRow = null"
                  >
                    @switch (competence.statusType) {
                      @case (colors.Green) {
                        <div
                          class="pill ok"
                          matTooltip="
                {{ competenceNamesMap[competence.competenceId] }}:
                {{ (competence.expiresAt ? 'expires' : 'ok') | translate | lowercase }}
                {{ competence.expiresAt | date }}"
                          [matTooltipDisabled]="!isMinifiedView"
                        >
                          @if (!isMinifiedView) {
                            {{
                              competence.expiresAt
                                ? (competence.expiresAt | date)
                                : ('ok' | translate | uppercase)
                            }}
                          }
                          @if (isMinifiedView) {
                            <mat-icon>done</mat-icon>
                          }
                          <app-equivalent-competences-tooltip
                            [competence]="competence"
                            icon=""
                          ></app-equivalent-competences-tooltip>
                        </div>
                      }
                      @case (colors.Yellow) {
                        <div
                          class="pill yellow"
                          matTooltip="
                {{ competenceNamesMap[competence.competenceId] }}:
                {{ 'dueSoon' | translate | lowercase }}
                {{ competence.expiresAt | date }}"
                          [matTooltipDisabled]="!isMinifiedView"
                        >
                          @if (!isMinifiedView) {
                            {{ competence.expiresAt | date }}
                          }
                        </div>
                      }
                      @case (colors.Orange) {
                        <div
                          class="pill orange"
                          matTooltip="
                {{ competenceNamesMap[competence.competenceId] }}:
                {{ 'preferred' | translate | lowercase }}
                {{ competence.expiresAt | date }}"
                          [matTooltipDisabled]="!isMinifiedView"
                        >
                          @if (!isMinifiedView) {
                            {{ competence.expiresAt | date }}
                          }
                        </div>
                      }
                      @case (colors.Red) {
                        <div
                          class="pill red"
                          matTooltip="
                {{ competenceNamesMap[competence.competenceId] }}:
                {{ 'expired' | translate | lowercase }}
                {{ competence.expiresAt | date }}"
                          [matTooltipDisabled]="!isMinifiedView"
                        >
                          @if (isMinifiedView) {
                            <mat-icon>priority_high</mat-icon>
                          }
                          @if (!isMinifiedView && competence.expiresAt) {
                            {{ competence.expiresAt | date }}
                          }
                        </div>
                      }
                      @case (colors.White) {
                        <div
                          class="pill not-required"
                          matTooltip="{{
                            competence.showOnMatrixIfNotRequired
                              ? ('competenceRegisteredButNotRequired' | translate)
                              : ''
                          }} {{
                            isMinifiedView &&
                            competenceNamesMap[competence.competenceId] &&
                            competence.expiresAt
                              ? competenceNamesMap[competence.competenceId] +
                                ': ' +
                                (competence.expiresAt | date)
                              : ''
                          }}"
                          [matTooltipDisabled]="false"
                        >
                          @if (!isMinifiedView && competence.showOnMatrixIfNotRequired) {
                            {{
                              competence.expiresAt
                                ? (competence.expiresAt | date)
                                : ('ok' | translate | uppercase)
                            }}
                          }
                          @if (isMinifiedView && competence.showOnMatrixIfNotRequired) {
                            <mat-icon>done</mat-icon>
                          }
                        </div>
                      }
                    }
                  </td>
                }
              </tr>
            }
          </tbody>
        } @else {
          @if ((loadingAction | actionInProgress | async) === false) {
            <div class="message">
              <mat-icon>info</mat-icon>
              <span>{{ 'noUsersInMatrix' | translate }}</span>
            </div>
          }
        }
      </table>
    } @else {
      @if ((loadingAction | actionInProgress | async) === false) {
        <div class="message">
          <mat-icon>info</mat-icon>
          <span>{{ 'noCompetencesInMatrix' | translate }}</span>
        </div>
      }
    }
    @if (summary.length && users.length) {
      <table class="matrix-footer sticky">
        <tbody>
          <tr>
            <td class="total">
              {{ 'ok' | translate | uppercase }} / {{ 'required' | translate | titlecase }}
            </td>
            @for (summaryItem of summary; track summaryItem) {
              <td class="total numbers">
                <div
                  class="cell top"
                  [class.warning]="isMinifiedView && summaryItem.statusType === colors.Red"
                >
                  {{ summaryItem.peopleOk }} / {{ summaryItem.allPeopleRequired }}
                </div>
              </td>
            }
          </tr>
          <tr>
            <td class="total">
              {{ 'ok' | translate | uppercase }} (%)
              @if (!isMinifiedView) {
                / {{ 'notOk' | translate | uppercase }} (%)
              }
            </td>
            @for (summaryItem of summary; track summaryItem) {
              <td class="total percents">
                <div class="cell bottom">
                  {{ summaryItem.percentageOkPeople }} %
                  @if (!isMinifiedView) {
                    / {{ summaryItem.percentageAllPeopleRequired }} %
                  }
                </div>
              </td>
            }
          </tr>
        </tbody>
      </table>
    }
    <!-- </div> -->
  </div>
</div>
